import Grid from '@mui/material/Grid';
import { styled } from '@mui/material/styles';

export const StyledListContainerGrid = styled(Grid, {
  shouldForwardProp: prop => prop !== 'hasMarginLeft' && prop !== 'hasMarginRight',
})<{ hasMarginLeft?: boolean; hasMarginRight?: boolean }>`
  position: relative;
  max-width: 100%;

  margin-left: ${({ theme, hasMarginLeft }) => (hasMarginLeft ? theme.spacing(2) : 0)};
  margin-right: ${({ theme, hasMarginRight }) => (hasMarginRight ? theme.spacing(2) : 0)};
`;
